var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 23.3333V11.0833L13.9997 4.91394L22.1663 11.0833V23.3333H16.109V15.8841H11.8903V23.3333H5.83301Z",
    fill: "#070707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeInactive);
export default __webpack_public_path__ + "static/media/homeInactive.531996d7b2c93eed48b99d3a13a54352.svg";
export { ForwardRef as ReactComponent };